<div class="ts-modal" [class.embedded]="from === 'create-timesheet'">

  <div class="ts-modal-loader" *ngIf="loading">
    <mat-spinner diameter="40"></mat-spinner>
  </div>

  <!-- HEADER (skipped when embedded inside the create-timesheet modal — outer header covers it) -->
  <div class="modal-head" *ngIf="from !== 'create-timesheet'">
    <div class="title-block">
      <h2>{{ auditTrail?.contractor || auditTrail?.title }}</h2>
      <span class="sub" *ngIf="auditTrail">
        <ng-container *ngIf="auditTrail.contractor && auditTrail.title">{{ auditTrail.title }}</ng-container>
        <ng-container *ngIf="auditTrail.contractor && auditTrail.title && auditTrail.client"> · </ng-container>
        <ng-container *ngIf="auditTrail.client">{{ auditTrail.client }}</ng-container>
        <ng-container *ngIf="auditTrail.subTitle && (auditTrail.title || auditTrail.client)"> · </ng-container>
        <ng-container *ngIf="auditTrail.subTitle">{{ auditTrail.subTitle }}</ng-container>
      </span>
    </div>

    <span class="pill"
      *ngIf="status"
      [class.approved]="status === STATUS.APPROVED"
      [class.submitted]="status === STATUS.SUBMITTED"
      [class.pending]="status === STATUS.PENDING"
      [class.rejected]="status === STATUS.REJECTED">
      <i class="bi"
        [class.bi-check-circle-fill]="status === STATUS.APPROVED"
        [class.bi-record-circle-fill]="status === STATUS.SUBMITTED"
        [class.bi-stopwatch-fill]="status === STATUS.PENDING"
        [class.bi-x-circle-fill]="status === STATUS.REJECTED"></i>
      {{ status }}
    </span>

    <button type="button" class="close-btn" (click)="close()" aria-label="Close">
      <i class="bi bi-x-lg"></i>
    </button>
  </div>

  <!-- TABS -->
  <div class="ts-tabs" *ngIf="!loading && from !== 'create-timesheet'">
    <button type="button" class="ts-tab"
      *ngIf="!(readonly && status === STATUS.PENDING)"
      [class.active]="tab === 'timesheetDetails'"
      (click)="tab = 'timesheetDetails'">
      Timesheet Details
    </button>
    <button type="button" class="ts-tab"
      [class.active]="tab === 'auditTrail'"
      (click)="tab = 'auditTrail'">
      Audit Trail
    </button>
    <button type="button" class="ts-tab"
      [class.active]="tab === 'comments'"
      (click)="tab = 'comments'">
      Comments
      <span class="ts-tab-badge" *ngIf="commentsList?.length">{{ commentsList.length }}</span>
    </button>
    <button type="button" class="ts-tab"
      [class.active]="tab === 'attachments'"
      (click)="tab = 'attachments'">
      Attachments
      <span class="ts-tab-badge" *ngIf="attachmentsArr?.length">{{ attachmentsArr.length }}</span>
    </button>
  </div>

  <!-- TIMESHEET DETAILS TAB -->
  <ng-container *ngIf="tab === 'timesheetDetails'">
    <form *ngIf="timesheetForm" [formGroup]="timesheetForm" (ngSubmit)="submitTimesheet()" class="ts-tab-form">

      <div class="modal-body">
        <ngb-accordion #acc="ngbAccordion" class="ts-day-accordion" [activeIds]="accordion_active_ids">
          <ng-container *ngFor="let timesheet_detail of timesheetDetails?.timesheet_details; let idx = index">
            <ngb-panel id="timsheet-ngbaccordion-panel-{{idx}}">

              <ng-template ngbPanelHeader let-opened="opened">
                <div class="ts-day-head" [class.open]="opened">
                  <button type="button" class="ts-day-toggle" ngbPanelToggle>
                    <i class="bi bi-chevron-down ts-day-chev" [class.open]="opened"></i>
                    <span class="ts-day-text">
                      <span class="weekday">{{ timesheet_detail.date | date: 'EEEE' }}</span>
                      <span class="date">{{ dataSharedService.tranformDate(timesheet_detail.date) }}</span>
                    </span>
                  </button>

                  <div class="ts-day-actions">
                    <span class="total-chip" *ngIf="timesheet_detail?.timesheet_display">
                      {{ timesheet_detail.timesheet_display }}
                    </span>
                    <button type="button"
                      class="icon-btn-sm"
                      *ngIf="from !== 'create-timesheet' && (timesheet?.status !== STATUS.APPROVED) && (user.role_uuid === ROLES.AGENCY || user.role_uuid === ROLES.CANDIDATE)"
                      (click)="changeTimesheetMode(); $event.stopPropagation();"
                      [title]="readonly ? 'Edit' : 'View'">
                      <i class="bi" [class.bi-pencil]="readonly" [class.bi-eye]="!readonly"></i>
                    </button>
                  </div>
                </div>
              </ng-template>

              <ng-template ngbPanelContent>
                <div class="ts-day-body">
                  <ng-container *ngFor="let field of fields?.field_values">
                    <ng-container *ngIf="field.field_type !== 'static'">
                      <div class="ts-field"
                        [class.full]="field.type === 'textarea' || field.label === 'Comments'">

                        <label class="ts-field-label">
                          {{ field.label }}
                          <span class="req" *ngIf="field.is_required">*</span>
                        </label>

                        <div class="ts-field-row">

                          <input *ngIf="field.type === 'text' || field.type === 'number'"
                            class="input-form"
                            [type]="field.type"
                            [readonly]="readonly"
                            [class.readonly]="readonly"
                            [formControlName]="field.label + '_' + idx"
                            (focus)="timesheetForm.controls[field.label+'_'+idx].focused = true"
                            (blur)="onBlurField(field.label+'_'+idx)"
                            [class.invalid]="timesheetForm.controls[field.label+'_'+idx].errors && timesheetForm.controls[field.label+'_'+idx].touched" />

                          <input *ngIf="field.type === 'time_range'"
                            class="input-form"
                            type="time"
                            min="06:00:00"
                            max="20:00:00"
                            placeholder="HH:mm:ss"
                            [readonly]="readonly"
                            [class.readonly]="readonly"
                            [formControlName]="field.label + '_' + idx"
                            [class.invalid]="timesheetForm.controls[field.label+'_'+idx]?.errors && timesheetForm.controls[field.label+'_'+idx]?.touched" />

                          <textarea *ngIf="field.type === 'textarea'"
                            class="input-form"
                            [readonly]="readonly"
                            [class.readonly]="readonly"
                            [formControlName]="field.label + '_' + idx"
                            (focus)="timesheetForm.controls[field.label+'_'+idx].focused = true"
                            (blur)="onBlurField(field.label+'_'+idx)"
                            [class.invalid]="timesheetForm.controls[field.label+'_'+idx].errors && timesheetForm.controls[field.label+'_'+idx].touched"></textarea>

                          <div class="select-wrap" *ngIf="field.type === 'dropdown' || field.type === 'single-select'">
                            <select
                              class="input-form"
                              [attr.disabled]="readonly ? 'disabled' : null"
                              [class.readonly]="readonly"
                              [formControlName]="field.label + '_' + idx"
                              (focus)="timesheetForm.controls[field.label+'_'+idx].focused = true"
                              (blur)="onBlurField(field.label+'_'+idx)"
                              [class.invalid]="timesheetForm.controls[field.label+'_'+idx].errors && timesheetForm.controls[field.label+'_'+idx].touched">
                              <option *ngFor="let option of field.values.split(',')" [value]="option">{{ option }}</option>
                            </select>
                          </div>

                          <button type="button"
                            class="icon-btn-sm ts-copy"
                            *ngIf="!readonly"
                            [style.visibility]="timesheetForm.controls[field.label+'_'+idx]?.focused ? 'visible' : 'hidden'"
                            (click)="copyValues(field.label, field.label+'_'+idx, idx)"
                            title="Copy this value to following days">
                            <i class="bi bi-files"></i>
                          </button>
                        </div>
                      </div>
                    </ng-container>
                  </ng-container>
                </div>
              </ng-template>

            </ngb-panel>
          </ng-container>
        </ngb-accordion>

        <div class="ts-error" *ngIf="error">
          <i class="bi bi-exclamation-triangle-fill"></i>
          <span>{{ error }}</span>
        </div>
      </div>

      <!-- FOOTER -->
      <div class="modal-foot" *ngIf="timesheet">
        <div class="left">
          <button type="button"
            class="btn btn-secondary"
            *ngIf="(timesheet.status !== STATUS.APPROVED) && (user.role_uuid === ROLES.AGENCY || user.role_uuid === ROLES.CANDIDATE)"
            (click)="changeTimesheetMode()">
            <i class="bi" [class.bi-pencil]="readonly" [class.bi-eye]="!readonly"></i>
            <span>{{ readonly ? 'Edit' : 'View' }}</span>
          </button>
        </div>
        <div class="right">
          <span class="total-chip" (click)="showAllAccordionItems(acc)" role="button">
            {{ timesheetDetails?.timesheet_details?.timesheet_total_type }}: {{ totalDays }} {{ timesheetDetails?.timesheet_details?.timesheet_total_type_suffix }}
          </span>
          <ng-container *ngIf="readonly && arFlag">
            <button type="button" class="btn btn-reject" (click)="onReject()">
              <i class="bi bi-x-circle"></i>
              <span>Reject</span>
            </button>
            <button type="button" class="btn btn-approve" (click)="onApprove()">
              <i class="bi bi-check-circle"></i>
              <span>Approve</span>
            </button>
          </ng-container>
          <ng-container *ngIf="!readonly">
            <button type="button" class="btn btn-secondary" (click)="changeTimesheetMode()">
              <span>Cancel</span>
            </button>
            <button type="submit" class="btn btn-primary" [disabled]="disabled">
              <i class="bi bi-check-lg"></i>
              <span>Submit</span>
            </button>
          </ng-container>
        </div>
      </div>
    </form>
  </ng-container>

  <!-- OTHER TABS -->
  <ng-container *ngIf="!loading && tab !== 'timesheetDetails'">
    <div class="modal-body">
      <app-audit-trail *ngIf="tab === 'auditTrail'"
        [auditTrailActivities]="auditTrailActivities"
        type="timesheet"
        [uuid]="timesheet.uuid"
        [from]="'timeSheetDetail'"
        [header]="auditTrail">
      </app-audit-trail>
      <app-comments *ngIf="tab === 'comments'"
        (onCommentEnter)="onCommentEnter($event)"
        [commentsList]="commentsList"
        [timesheet_uuid]="timesheet.uuid"
        [endPoint]="API_CONSTANT.TIMESHEET_COMMENTS"
        [parentKey]="'timesheet_uuid'">
      </app-comments>
      <app-attachments *ngIf="tab === 'attachments'"
        (onNewAttachment)="onNewAttachment($event)"
        [attachmentsArr]="attachmentsArr"
        [timesheet_uuid]="timesheet.uuid">
      </app-attachments>
    </div>
  </ng-container>

</div>
